import { ChangeDetectorRef, Component, ElementRef, inject, Input } from '@angular/core';
import { PdfViewerModule } from 'ng2-pdf-viewer';

@Component({
    selector: 'ui-v2-pdf-viewer',
    standalone: true,
    imports: [PdfViewerModule],
    template: `
        @if (src) {
            <pdf-viewer
                [src]="src"
                [render-text]="true"
                [original-size]="false"
                class="display-block"
                (page-rendered)="onPageRendered($event)"
                (after-load-complete)="onLoadComplete($event)"
            ></pdf-viewer>
        }
    `,
})
export class PdfViewComponent {
    @Input() public src: string;

    private readonly elementRef: ElementRef = inject(ElementRef);
    private readonly cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

    /**
     * Handles actions to be performed after a page has been rendered.
     * This is required to render the PDF with automatic width/height based on the contents
     */
    public onPageRendered(event: any) {
        this.setPdfContainerStyle();
    }

    public onLoadComplete(event): void {
        this.setPdfContainerStyle();
    }

    /**
     * Sets the style for the PDF container element in the DOM.
     * Adjusts the `position`, `display`, `width`, and `height` properties for layout purposes,
     * forces a layout recalculation, and temporarily manipulates the scroll position to ensure proper rendering.
     *
     * This looks like it's required in order to render it consistently across browsers.
     *
     * @param {void} Does not return a value.
     *
     * @return {void} Does not return a value.
     */
    private setPdfContainerStyle(): void {
        const element = this.elementRef.nativeElement.getElementsByClassName('ng2-pdf-viewer-container')[0];
        if (!element) return;
        setTimeout(() => {
            element.style.position = 'relative';
            element.style.display = 'block';
            element.style.width = '800px';
            element.style.height = '800px';

            // Force layout recalculation
            const forceReflow = element.offsetHeight;

            // Simulate a tiny scroll
            const currentScrollTop = element.scrollTop;
            element.scrollTop = 1;
            setTimeout(() => {
                element.scrollTop = currentScrollTop;
                this.cdr.detectChanges();
            }, 50);
        }, 0);
    }
}
